module.exports = __webpack_public_path__ + "img/copy_id.4daeef8d.gif";